import React from "react";

const RecurrentCond = () => {
  return (
    <div className="bg-gray-10 !p-2 flex flex-col max-w-[243px] text-teal-300 text-body-sm text-left font-normal">
      <p className="p-2">
        Repeated episodes of sinusitis and if the condition
        does not get better with treatment.
      </p>
    </div>
  );
};

export default RecurrentCond;
